import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventPhrasebookSearch,
} from 'src/types/googleAnalyticsEvents';

export type SearchData = {
  query: string;
  resultsLength: number;
};

export function useEventPhrasebookPageSearch({
  query,
  resultsLength,
}: SearchData): AnalyticsEventPhrasebookSearch {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.phrasebookSearch,
      [AnalyticsDataProperty.searchQuery]: query,
      [AnalyticsDataProperty.searchResults]: resultsLength,
      ...trackedPageContext,
    }),
    [query, resultsLength, trackedPageContext],
  );
}
